import s from '@/styles/components/Modal.module.scss'
import { ForwardedRef, forwardRef, PropsWithChildren, RefObject, useEffect } from 'react'
import { MotionDiv } from '@/components'
import { fixScroll, unfixScroll } from '@tmap-web-lib/utils'

interface Props extends PropsWithChildren {
  backdropRef?: RefObject<HTMLDivElement>;
}

const backdropVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
}
const sheetVariants = {
  initial: { y: '100%', opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: '100%', opacity: 0 },
}
const timing = { duration: 0.3, ease: 'easeOut' as const }

const ModalSheet = forwardRef((props: Props, ref: ForwardedRef<HTMLDivElement>) => {
  const { backdropRef, children } = props

  useEffect(() => {
    fixScroll('fix_scroll')
    return () => unfixScroll('fix_scroll')
  }, [])

  return (
    <div ref={ref} className={s.sheet}>
      <MotionDiv
        ref={backdropRef}
        className={s.backdrop}
        variants={backdropVariants}
        transition={timing}
        initial="initial"
        animate="animate"
        exit="exit"
      />
      <MotionDiv
        className={s.sheet_container}
        variants={sheetVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={timing}
      >
        {children}
      </MotionDiv>
    </div>
  )
})

ModalSheet.displayName = 'ModalSheet'
export { ModalSheet }
